// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
/*解决video.js中出现no compatible source was found for this media的问题*/
const hls =require("videojs-contrib-hls")
Vue.use(hls)

const originalPush = VueRouter.prototype.push
// 重写了原型上的push方法，统一的处理了错误信息
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.config.productionTip = false



/**/
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

// 图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

/**/
import 'element-ui/lib/theme-chalk/index.css'
//引入多语言支持
import i18n from './utils/i18n'
import ElementUI from 'element-ui'
Vue.use(ElementUI)
/* animate.css */
import 'wowjs/css/libs/animate.css'
import  VueGoogleMaps from 'vue2-google-maps'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,     //挂载i18n
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js